import { render, staticRenderFns } from "./westoreIcon.vue?vue&type=template&id=a0ce36de&"
import script from "./westoreIcon.vue?vue&type=script&lang=js&"
export * from "./westoreIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports